import type { RouteRecordRaw } from 'vue-router'
import { MY_ROUTES } from '@/router/routes.enum'
import { redirectIfAuthenticated } from '@/router/guards'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/sign_up',
    name: MY_ROUTES.SIGN_UP,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/my/modules/auth/views/SignUp.view.vue'),
    props: true,
    meta: {
      redirectNotification: 'You cannot signup when you are already signed in.'
    }
  },
  {
    path: '/sign_in',
    name: MY_ROUTES.SIGN_IN,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/my/modules/auth/views/SignIn.view.vue'),
    meta: {
      redirectNotification: 'You are already signed in'
    }
  },
  {
    path: '/account/verify/:token',
    name: MY_ROUTES.VERIFY_ACCOUNT,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/my/modules/auth/views/VerifyAccount.view.vue'),
    meta: {
      redirectNotification: 'You cannot complete a new signup when you are already signed in'
    }
  },
  {
    path: '/account/verify_email',
    name: MY_ROUTES.VERIFY_EMAIL_CHANGE,
    component: () => import('@/my/modules/auth/views/VerifyEmailChange.view.vue')
  },
  {
    path: '/sign_out',
    name: MY_ROUTES.SIGN_OUT,
    component: () => import('@/my/modules/auth/views/SignOut.view.vue')
  },
  {
    path: '/password/reset',
    name: MY_ROUTES.SEND_RESET_PASSWORD_INSTRUCTIONS,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/my/modules/auth/views/SendResetPasswordInstructions.view.vue'),
    meta: {
      redirectNotification:
        'Use the Password & Security page to reset your password when already signed in'
    }
  },
  {
    path: '/password/new',
    name: MY_ROUTES.RESET_PASSWORD,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/my/modules/auth/views/ResetPassword.view.vue'),
    meta: {
      redirectNotification:
        'Use the Password & Security page to reset your password when already signed in'
    }
  },
  {
    path: '/sessions/magic_link/verify',
    name: MY_ROUTES.VERIFY_MAGIC_LINK,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/my/modules/auth/views/VerifyMagicLink.view.vue'),
    meta: {
      redirectNotification: 'Cannot use a magic link when already signed in'
    }
  },
  {
    path: '/verify_identity/magic_link/verify',
    name: MY_ROUTES.VERIFY_IDENTITY_MAGIC_LINK,
    component: () => import('@/my/modules/auth/views/VerifyIdentityMagicLink.view.vue')
  },
  {
    path: '/account_credit/claim',
    name: MY_ROUTES.CLAIM_ACCOUNT_CREDIT,
    component: () => import('@/my/modules/account-credits/views/ClaimAccountCredit.view.vue')
  },
  {
    path: '/404',
    name: MY_ROUTES.NOT_FOUND,
    component: () => import('@/my/modules/auth/views/NotFound.view.vue')
  }
]
